import ProductsTable from "components/products/ProductsTable"

export default function ProductsPage (){
  return(
      <div className="p-5 h-full overflow-y-auto">
        <ProductsTable/>
      </div>
  )
}
